<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom-narrow"></div>

        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <servers-overview :tableData="tableData" />
            </div>
        </div>
    </div>
</template>

<script>
import { serversMixin, ServersOverview } from 'relapp-servers';

export default {
    components: {
        ServersOverview
    },
    metaInfo: {
        title: trans('page.servers.title')
    },
    mixins: [serversMixin]
};
</script>
